<span [ngSwitch]="id">
  <span class="badge order-prepared" *ngSwitchCase="2"> {{'orderItemStatusValue.'+id | translate}} </span>
  <span class="badge order-delivered" *ngSwitchCase="3"> {{'orderItemStatusValue.'+id | translate}}</span>
  <span class="badge order-canceled" *ngSwitchCase="4"> {{'orderItemStatusValue.'+id | translate}}</span>
  <span class="badge order-product-preparation" *ngSwitchDefault> {{'orderItemStatusValue.'+id | translate}}</span>
</span>